/* eslint-disable max-len */
const React = require('react');

const Cabal = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svelte-pvez5e medium-3XCtad"><path d="M12.9239 3L20.8674 11.1731C21.3109 11.6241 21.3109 12.3759 20.8674 12.8269L12.937 21V16.4351L16.6674 12.5809C16.9804 12.2665 16.9804 11.7472 16.6674 11.4191L12.937 7.55125V3H12.9239ZM10.4631 7.55125L6.73262 11.4191C6.41958 11.7335 6.41958 12.2528 6.73262 12.5809L10.4631 16.4351V21L2.53262 12.8269C2.08914 12.3759 2.08914 11.6241 2.53262 11.1731L10.4761 3V7.55125H10.4631Z" fill="#00609C" /></svg>
);

module.exports = Cabal;
